
<template>

  <div class="container">

    <Home v-if="name == ''" v-on:change_page="changePage" />

    <Side
      v-on:event_child="eventChild"
      v-on:change_page="changePage"
      v-else-if="name == 'Left'"
      :name="name"
      :correctAnswer="2"
    />

    <Side
      v-on:event_child="eventChild"
      v-on:change_page="changePage"
      v-else-if="name == 'Front'"
      :name="name"
      :correctAnswer="3"
    />

    <Side
      v-on:event_child="eventChild"
      v-on:change_page="changePage"
      v-else-if="name == 'Right'"
      :name="name"
      :correctAnswer="3"
    />

    <b-modal v-model="showQuestion" :can-cancel="true" >
      <Question />
    </b-modal>
  </div>
</template>

<script>
import { api } from "./api.js";
import Home from "./Home.vue";
import Side from "./Side.vue";
import Question from "./Question.vue";

export default {
  name: "App",
  data() {
    return {
      name: "",
      answers: {
        left: 0,
        front: 0,
        right: 0,
      },
      showQuestion: false,
    };
  },
  components: {
    Side,
    Home,
    Question,
  },
  computed: {
    isAllAnswered() {
      const r = this.answers.left == 1 && this.answers.right == 1 && this.answers.front == 1
      console.log(r);
      return r;
    },
  },
  methods: {
    changePage: function (id) {
      console.log("page", id);
      this.name = id;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    eventChild: function (id) {
      this.answers[id] = 1;
      console.log("Event from child component emitted", id, this.answers);

        if (this.isAllAnswered) {
            const self = this;
            setTimeout(function () {
              self.showQuestion = true;
            }, 5000);
        }
    },
  },
  mounted() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    console.log(params.side);

    if (params.side == null) this.name = "";
    else if (params.side.toLowerCase() == "left") this.name = "Left";
    else if (params.side.toLowerCase() == "front") this.name = "Front";
    else if (params.side.toLowerCase() == "right") this.name = "Right";
    else this.name = "";

    this.$nextTick(function () {
      //console.log(api)
      if (params.dev == "true") api.dev();
    });
  },
};
</script>

